import Seo from '../components/Seo.jsx'
import Container from '../components/Container.jsx'
import PageHeader from '../components/PageHeader.jsx'
import ServiceCard from '../components/ServiceCard.jsx'
import CTA from '../components/CTA.jsx'
import { services } from '../data/services.js'

export default function Services() {
  return (
    <>
      <Seo
        title="Services"
        description="Software, app and website development, UI/UX, data analytics, AI, IoT, drones, cyber security, SIEM/SOC, testing, digital marketing and more."
        path="/services"
      />
      <main className="pt-20">
        <PageHeader
          eyebrow="We offer"
          title="Everything you need to build, secure and grow"
        />

        <section className="py-16">
          <Container>
            <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
              {services.map((s) => (
                <ServiceCard key={s.slug} service={s} />
              ))}
            </div>
          </Container>
        </section>

        <CTA />
      </main>
    </>
  )
}
